export var DEFAULT_ENABLED = true;
export var ANIMATION_CONTAINER_ID = 'page-transition';
export var ANIMATION_IN_DURATION_MS = 200;
export var ANIMATION_OUT_DURATION_MS = 200;
export var FADE_IN_CLASS = 'fade-in';
export var FADE_OUT_CLASS = 'fade-out';
export var SPINNING_CLASS = 'spinning';
export var FADE_PAGE_TRANSITION = 'fade';